import type { TOC } from '@ember/component/template-only'
import { LinkTo } from '@ember/routing'
import { array } from '@ember/helper'
import { hash } from '@ember/helper'
import { t } from 'ember-intl'
import imgSizes from 'teacher-ui-client/modifiers/img-sizes'
import placeholderImage from 'teacher-ui-client/helpers/placeholder-image'
import type BookLibraryBook from 'teacher-ui-client/models/book-library/book'

interface Signature {
  Element: HTMLDivElement | HTMLAnchorElement
  Args: {
    bookPreviewCover: BookLibraryBook['bookPreviewImg']
    bookFullCover: BookLibraryBook['bookFullImg']
    linkToBookDetail?: boolean
    bookId: string
    bookCoverAlt: string
    onCoverLoad: () => void
  }
}

export const BookLibraryBookCardBody: TOC<Signature> = <template>
  {{#if @bookPreviewCover}}
    {{#if @bookFullCover}}
      {{#let
        "h-56 object-contain border border-dusty-black-200"
        (placeholderImage width=@bookPreviewCover.width height=@bookPreviewCover.height)
        (array (hash src=@bookPreviewCover.url onLoad=@onCoverLoad) (hash src=@bookFullCover.url))
        as |imgClass placeholder sizes|
      }}
        {{#if @linkToBookDetail}}
          <LinkTo
            data-test-book-card-body
            aria-label={{t "bookLibrary.components.card.viewBookDetail"}}
            class="inline-block"
            ...attributes
            @query={{hash bookId=@bookId bookTab="bookDetails"}}
          >
            <img class={{imgClass}} src={{placeholder}} alt={{@bookCoverAlt}} {{imgSizes sizes=sizes}} />
          </LinkTo>
        {{else}}
          <div data-test-book-card-body class="inline-block" ...attributes>
            <img class={{imgClass}} src={{placeholder}} alt={{@bookCoverAlt}} {{imgSizes sizes=sizes}} />
          </div>
        {{/if}}
      {{/let}}
    {{/if}}
  {{/if}}
</template>

export default BookLibraryBookCardBody
